<template>
  <div class="vip-member-info" :class="{ 'is-vip': isVip }">
    <div class="left">
      <div class="title">{{ isVip ? t('vip.title.renew') : t('vip.title.open') }}</div>
      <div class="sub">
        <span>{{ isVip ? t('vip.subtitle.joined') : t('vip.subtitle.join') }}</span>
        <span class="plus-badge">
          <img class="plus-icon" :src="badgeIcon" alt="" />
          <!-- <span>Plus</span> -->
        </span>
        <span>{{ t('vip.subtitle.desc') }}</span>
      </div>
      <div class="features">
        <div class="feature">
          <svg v-if="isVip" t="1778047030297" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5039" width="16" height="16"><path d="M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608z" p-id="5040" fill="#ffffff"></path><path d="M359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z" p-id="5041" fill="#ffffff"></path></svg>
          <svg v-else t="1778047030297" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5039" width="16" height="16"><path d="M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608z" p-id="5040" fill="#4c7fd6"></path><path d="M359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z" p-id="5041" fill="#4c7fd6"></path></svg>
          <span>{{ t('vip.feature.lower.price') }}</span>
        </div>
        <div class="feature">
          <svg v-if="isVip" t="1778047030297" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5039" width="16" height="16"><path d="M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608z" p-id="5040" fill="#ffffff"></path><path d="M359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z" p-id="5041" fill="#ffffff"></path></svg>
          <svg v-else t="1778047030297" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5039" width="16" height="16"><path d="M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608z" p-id="5040" fill="#4c7fd6"></path><path d="M359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z" p-id="5041" fill="#4c7fd6"></path></svg>
          <span>{{ t('vip.feature.long.term.save') }}</span>
        </div>
        <div class="feature">
          <svg v-if="isVip" t="1778047030297" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5039" width="16" height="16"><path d="M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608z" p-id="5040" fill="#ffffff"></path><path d="M359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z" p-id="5041" fill="#ffffff"></path></svg>
          <svg v-else t="1778047030297" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5039" width="16" height="16"><path d="M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608z" p-id="5040" fill="#4c7fd6"></path><path d="M359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z" p-id="5041" fill="#4c7fd6"></path></svg>
          <span>{{ t('vip.feature.exclusive.rights') }}</span>
        </div>
        <div class="feature">
          <svg v-if="isVip" t="1778047030297" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5039" width="16" height="16"><path d="M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608z" p-id="5040" fill="#ffffff"></path><path d="M359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z" p-id="5041" fill="#ffffff"></path></svg>
          <svg v-else t="1778047030297" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5039" width="16" height="16"><path d="M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608z" p-id="5040" fill="#4c7fd6"></path><path d="M359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z" p-id="5041" fill="#4c7fd6"></path></svg>
          <span>{{ t('vip.feature.priority.service') }}</span>
        </div>
      </div>

      <div v-if="!isVip" class="price">
        <span class="currency">¥</span>
        <span class="amount">{{ price }}</span>
        <span class="unit">{{ t('vip.price.unit') }}</span>
      </div>

      <div v-else-if="expireText" class="expire">{{ t('vip.expire.prefix') }}{{ expireText }}</div>
    </div>

    <div class="right">
      <div v-if="showAction" class="action" @click="emit('action',9)">{{ isVip ? t('vip.action.renew') : t('vip.action.open') }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import isVipIcon from '@/assets/usercenter/isvip.png'
import noVipIcon from '@/assets/usercenter/no_vip.png'

const { t } = useI18n()
const emit = defineEmits(['action'])

const props = defineProps({
  isVip: {
    type: Boolean,
    default: false,
  },
  expireDate: {
    type: [String, Number, Date],
    default: null,
  },
  price: {
    type: [String, Number],
    default: 188,
  },
})

const badgeIcon = computed(() => {
  return props.isVip ? isVipIcon : noVipIcon
})

const showAction = computed(() => {
  if (!props.isVip) return true
  return !(props.expireDate === null || props.expireDate === undefined || props.expireDate === '')
})

const expireText = computed(() => {
  if (!props.isVip) return ''
  if (props.expireDate === null || props.expireDate === undefined || props.expireDate === '') return t('vip.expire.permanent')

  const raw = props.expireDate
  if (raw instanceof Date) return t('vip.expire.until', { date: formatDate(raw) })

  if (typeof raw === 'number') {
    const d = new Date(raw)
    if (Number.isNaN(d.getTime())) return ''
    return t('vip.expire.until', { date: formatDate(d) })
  }

  if (typeof raw === 'string') {
    const d = new Date(raw)
    if (!Number.isNaN(d.getTime())) return t('vip.expire.until', { date: formatDate(d) })
    return t('vip.expire.until', { date: raw })
  }

  return ''
})

function pad2(n) {
  return String(n).padStart(2, '0')
}

function formatDate(d) {
  const yyyy = d.getFullYear()
  const mm = pad2(d.getMonth() + 1)
  const dd = pad2(d.getDate())
  const hh = pad2(d.getHours())
  const mi = pad2(d.getMinutes())
  const ss = pad2(d.getSeconds())
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`
}
</script>

<style scoped lang="less">
.vip-member-info {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  border-radius: 10px;
  padding: 16px 18px;
  background: #f6f7f9;
  position: relative;
  overflow: hidden;
  min-height: 96px;
}

.vip-member-info.is-vip {
  color: #f2e6cf;
  background: #2b2b2b;
  background-image: url('~@/assets/usercenter/isvip_bg.png');
  background-size: cover;
  background-position: center;
}

.left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: #2a2a2a;
}

.vip-member-info.is-vip .title {
  color: #f3e2bf;
}

.sub {
  font-size: 13px;
  color: #6b6b6b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.vip-member-info.is-vip .sub {
  color: rgba(243, 226, 191, 0.85);
}

.plus-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  width: 53px;
}

.plus-icon {
  width: 53px;
  height: 18px;
  display: block;
}

.features {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.feature {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #2f6ee5;
}

.vip-member-info.is-vip .feature {
  color: rgba(255, 255, 255, 0.85);
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2f6ee5;
  position: relative;
}

.vip-member-info.is-vip .dot {
  background: rgba(255, 255, 255, 0.75);
}

.dot::after {
  content: '';
  position: absolute;
  left: 3px;
  top: 1px;
  width: 3px;
  height: 6px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(45deg);
}

.price {
  margin-top: 2px;
  display: flex;
  align-items: baseline;
  gap: 3px;
  color: #d93737;
}

.currency {
  font-size: 12px;
}

.amount {
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
}

.unit {
  font-size: 12px;
  color: #d93737;
}

.expire {
  margin-top: 2px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.78);
}

.right {
  display: flex;
  align-items: center;
}

.action {
  cursor: pointer;
  user-select: none;
  height: 34px;
  padding: 0 16px;
  border-radius: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  background: #1f1f1f;
  color: #f3e2bf;
}

.vip-member-info:not(.is-vip) .action {
  background: linear-gradient( 90deg, #FADBAB 0%, #F2C68C 100%), #F3D4A4;
  font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 14px;
color: #323232;
}
</style>
